export class FormuleConfig {
    id?: number;
    name: string;
    description: string;
    formule_sql: string;
    created_at: string;
    updated_at: string;
    user_created: string;
    user_updated_at: string;
    active: boolean;
    isOff: boolean = false;
}